export default __webpack_public_path__ + "pgnv-assets/b92625744bfcb8422ff6b2ddba5c5c60.png";